import type {
	DefinitionNode,
	DocumentNode,
	FragmentDefinitionNode,
	NameNode,
	SelectionSetNode,
} from 'graphql';
import { set, update } from 'lodash/fp';

import type { GqlOperationInfo } from './gqlEngineUtils';

/**
 * Utility for @client resolvers, allows bind @client field selectionSet to the query which is used to gather the data.
 * @param query - the query which is used in custom resolver to gather data for @client field
 * @param gqlOperationInfo - the info object which is provided as 4th argument to the resolver
 */
export const insertSelectionSet = (
	query: DocumentNode,
	gqlOperationInfo: GqlOperationInfo
): DocumentNode =>
	update(
		[`definitions`],
		(definitions) => {
			return [
				set(
					[`selectionSet`, `selections`, 0, `selectionSet`],
					gqlOperationInfo.field.selectionSet,
					definitions[0]
				),
				...Object.values(gqlOperationInfo.fragmentMap),
			];
		},
		query
	);

const createNameNode = (name: string): NameNode => ({ kind: `Name`, value: name });

export const selectionSetToFragment = (
	fragmentName: string,
	typename: string,
	selectionSet: SelectionSetNode
): FragmentDefinitionNode => ({
	kind: `FragmentDefinition`,
	name: createNameNode(fragmentName),
	selectionSet,
	typeCondition: {
		kind: `NamedType`,
		name: createNameNode(typename),
	},
});

export const wrapInDocument = (definitions: DefinitionNode[]): DocumentNode => ({
	definitions,
	kind: `Document`,
});
